module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ko_okinawa-ebe7f11f8784924c46ed243dacae9d76.jpg";